export class ReferringDoctor {
  id: string;
  name = '';
  address: string;
  disabled: boolean;
  details: string;
}
